import { render } from "./forget-password-form.vue?vue&type=template&id=5a2f9272&scoped=true"
import script from "./forget-password-form.vue?vue&type=script&lang=js"
export * from "./forget-password-form.vue?vue&type=script&lang=js"

import "./forget-password-form.vue?vue&type=style&index=0&id=5a2f9272&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2f9272"]])

export default __exports__